import script from "./CoachForm.vue?vue&type=script&setup=true&lang=js"
export * from "./CoachForm.vue?vue&type=script&setup=true&lang=js"

import "./CoachForm.vue?vue&type=style&index=0&id=b05c27b6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Anteater\\Desktop\\projects\\main-prj-01-starting-setup\\main-prj-01-starting-setup\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b05c27b6"]])

export default __exports__